import axios from "axios";
//const API_ROUTE = `${process.env.API_ROUTE}`;
//export const API_ROUTE = `http://localhost:5067`;
export const API_ROUTE = `https://api.tmwebstudios.com`;

axios.interceptors.response.use(undefined, async function (err) {
  console.log(err);
  if (
    err.response.status === 401 ||
    err.response.data.message === "401 Unauthorized"
  ) {
    // Attempt to refresh token
    const userId = parseInt(localStorage.getItem("userId"));
    const token = localStorage.getItem("refreshToken");
    if (!(userId && token)) {
      window.location = "/login";
      return;
    }
    const response = await axios.post(`${API_ROUTE}/auth/token/${userId}`, {
      refreshToken: token,
    });
    if (response.status === 200) {
      localStorage.setItem("accessToken", response.data.accessToken);
      localStorage.setItem("refreshToken", response.data.refreshToken);
      return true;
    } else {
      // Re-direct to login on fail to refresh
      window.location = "/login";
    }
  }
  return Promise.reject(err);
});

export function get_image_url(id) {
  return `${API_ROUTE}/file/image/${id}`;
}
export async function get(route) {
  const token = localStorage.getItem("accessToken");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const response = await axios.get(`${API_ROUTE}${route}`);
  return response.data;
}
export async function put(route, data) {
  const token = localStorage.getItem("accessToken");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const response = await axios.put(`${API_ROUTE}${route}`, data);
  return response.data;
}
export async function postMultipart(route, data) {
  const token = localStorage.getItem("accessToken");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const response = await axios.post(`${API_ROUTE}${route}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.status === 200;
}
export async function post(route, data) {
  const token = localStorage.getItem("accessToken");
  axios.defaults.headers.common = { Authorization: `Bearer ${token}` };
  const response = await axios.post(`${API_ROUTE}${route}`, data);
  return response.data;
}

export async function login(lvm) {
  const response = await axios.post(`${API_ROUTE}/auth/login`, lvm);
  if (response.status === 200) {
    localStorage.setItem("accessToken", response.data.accessToken);
    localStorage.setItem("refreshToken", response.data.refreshToken);
    localStorage.setItem("userId", response.data.userId);
    localStorage.setItem("firstName", response.data.firstName);
    localStorage.setItem("lastName", response.data.lastName);
    return true;
  }
  return false;
}
